module.exports = __webpack_public_path__ + "img/nt87-01-82-1.prt.31563d27.jpg";